import "./MetaDocAISummary.scss";

import { useEffect, useRef, useState } from "react";
import AdvancedTextArea from "components/inputs/TextArea/AdvancedTextArea";
import type { TabId } from "../metadoc.types";

type MetaDocAISummaryProps = {
  summary: string;
  tabId: TabId;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  isEditable?: boolean;
  searchTerm?: string;
  summaryContext?: {
    contextTitle: string;
    contextValue: string;
  };
};

const MetaDocAISummary = ({
  summary,
  tabId,
  onChange,
  onBlur,
  isEditable = true,
  searchTerm,
  summaryContext,
}: MetaDocAISummaryProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const visibilityTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  // trigger fade-in animation when tab changes
  useEffect(() => {
    if (visibilityTimerRef.current) {
      clearTimeout(visibilityTimerRef.current);
      visibilityTimerRef.current = null;
    }

    setIsVisible(false);
    visibilityTimerRef.current = setTimeout(() => {
      visibilityTimerRef.current = null;
      setIsVisible(true);
    }, 50);

    return () => {
      if (visibilityTimerRef.current) {
        clearTimeout(visibilityTimerRef.current);
        visibilityTimerRef.current = null;
      }
    };
  }, [tabId]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div
      className={`metadoc-ai-summary ${isVisible ? "metadoc-ai-summary--visible" : ""} ${isCollapsed ? "metadoc-ai-summary--collapsed" : ""}`}
    >
      <div className="metadoc-ai-summary__header">
        <div className="metadoc-ai-summary__badge">
          <span className="material-icons">auto_awesome</span>
          <span className="metadoc-ai-summary__badge-text">
            AI Generated Summary
          </span>
        </div>
        <div className="metadoc-ai-summary__header-actions">
          {summaryContext && (
            <div className="metadoc-ai-summary__context">
              <span className="metadoc-ai-summary__context-title">
                {summaryContext.contextTitle}
              </span>
              <span className="metadoc-ai-summary__context-value">
                {summaryContext.contextValue}
              </span>
            </div>
          )}
          <button
            className="metadoc-ai-summary__collapse-btn"
            onClick={toggleCollapse}
            title={isCollapsed ? "Expand summary" : "Collapse summary"}
          >
            <span className="material-icons">
              {isCollapsed ? "expand_more" : "expand_less"}
            </span>
          </button>
        </div>
      </div>
      {!isCollapsed && (
        <div className="metadoc-ai-summary__content">
          <div className="metadoc-ai-summary__rich-content">
            <AdvancedTextArea
              value={summary}
              name={`metadoc-summary-${tabId}`}
              onChange={onChange ?? (() => {})}
              onBlur={onBlur}
              isEditable={isEditable}
              searchTerm={searchTerm}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MetaDocAISummary;
